<template>
	<div class="agree-bg">
		<div class="main-xieyi-content">
			<div class="main-xieyi-title">隐私政策</div>
			<div class="main-xieyi-pcontent" style="margin-top:20px;">
				<p class="p-content">
					智慧生活10000号”或“我们”深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。根据法律法规、国家标准等规定，制定以下《智慧生活10000号隐私政策》（以下简称本政策或本隐私政策）。</p>
				<p class="p-content">
					本《隐私政策》适用于我们提供的一切智慧生活10000号服务。当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称“特定条款”）的保护，在此情况下特定条款与本政策条款同时对您产生效力。如特定条款与本《隐私政策》条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。如我们提供的某一单项服务不适用本《隐私政策》的，该服务中会以适当方式明示排除适用本《隐私政策》。
				</p>
				<p class="p-content">请在使用我们的产品或服务前，仔细阅读并充分了解本隐私政策内容。一旦您开始使用我们的产品或服务，即表示您已充分理解并同意本政策。</p>

			</div>
			<div class="main-xieyi-pcontent">
				<p class="p-title">1.我们如何收集和使用您的个人信息：</p>
				<p class="p-content">智慧生活10000号仅会出于本政策所述的以下目的，收集您的个人信息：</p>
				<p class="p-content">1.1 注册用户</p>
				<p class="p-content">
					帮助您完成注册以便于我们为您提供服务，您需要提供基本注册信息，例如手机号码、电子邮箱、地址等，并创建您的用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为智慧生活10000号用户及提供上述信息。
				</p>
				<p class="p-content">1.2向您提供商品或服务</p>
				<p class="p-content">我们所收集和使用的信息是为您提供智慧生活10000号服务的必要条件，如缺少相关信息，我们将无法为您提供智慧生活10000号服务的核心内容，例如：</p>
				<p class="p-content-chid">
					1.2.1在部分服务项目中，为便于向您交付商品或服务，您需提供收货人个人身份信息、姓名、收货地址、邮政编码、收货人、联系电话、支付状态等信息。如果您拒绝提供此类信息，我们将无法完成相关交付服务。如您通过智慧生活10000号服务为其他人订购商品或服务，您需要提供该实际订购人的前述信息。向我们提供该实际订购人的前述信息之前，您需确保您已经取得其授权同意。
				</p>
				<p class="p-content-chid">
					1.2.2对您购买的商品或服务项目开具发票时，您需要提供企业开票信息（公司名称、注册地址、信用代码、地址及联系电话、开户行及帐号）。若您不提供工上述信息将无法为您开具发票，但不影响您对购买的商品或／和服务的使用。</p>
				<p class="p-content-chid">1.2.3当您想要使用智慧生活10000号企业VIP服务（以下简称企业VIP服务）时，您需要提供企业基本信息（
					企业注册名称、社会统一信用代码、营业执照等），以便智慧生活10000号验证企业信息的真实有效性、签订授权协议以及为您提供符合企业需求的必要或个性化服务。您不提供上述信息或提供的信息有不属实、不合法规，您的权益将得不到有效保障。</p>
				<p class="p-content-chid">1.2.4为展示您账户的订单信息，我们会收集您在使用智慧生活10000号服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。</p>
				<p class="p-content-chid">1.2.5当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
				<p class="p-content-chid">
					1.2.6为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、支付机构、物流公司等收集与交易进度相关的您的交易、支付、物流信息，或将您的相关交易信息共享给上述服务提供者。</p>


				<p class="p-content">1.3向您推送消息</p>
				<p class="p-content-chid">
					1.3.1为您展示和推送商品或服务。我们可能使用您的信息，您的浏览及搜索记录、设备信息、位置信息、订单信息，提取您的浏览、搜索偏好、行为习惯、位置信息等特征，并基于特征标签通过电子邮件、短信或其他方式向您发送营销信息，提供或推广我们或第三方的商品和服务。
				</p>
				<p class="p-content-chid">
					1.3.2向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。如您不希望继续接收我们推送的消息，您可要求我们停止推送；但我们依法律规定或单项服务的服务协议约定发送消息的情形除外。
				</p>

				<p class="p-content">1.4为您提供安全保障</p>
				<p class="p-content">为确保您身份真实性、向您提供更好的安全保障，您可以向我们提供身份证明、面部特征等生物识别信息等个人敏感信息以完成实名认证。
					除身份验证外，我们可能将您的信息用于客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的服务的安全性；我们可能使用或整合我们所收集的您的信息，以及我们的合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
				</p>

				<p class="p-content">1.5改进我们的服务</p>
				<p class="p-content">
					我们可能将通过某一项智慧生活10000号服务所收集的信息，用于我们的其他服务。例如：在您使用某一项智慧生活10000号服务时所收集的您的信息，可能在另一项智慧生活10000号服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关智慧生活10000号服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。
				</p>
				<p class="p-content">
					您了解并同意，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。</p>
				<p class="p-content">如果我们将您的信息用于本《隐私政策》中未载明的其他用途，会事先征求您同意。</p>

				<p class="p-content">1.6需征得授权同意的例外情况</p>
				<p class="p-content">根据相关法律法规规定，以下情形中我们可能会共享、转让、公开披露您的个人信息无需征得您的同意：</p>
				<p class="p-content-chid">1.6.1与国家安全、国防安全有关的。</p>
				<p class="p-content-chid">1.6.2与公共安全、公共卫生、重大公共利益有关的。</p>
				<p class="p-content-chid">1.6.3涉及公检法的调查或诉讼的。</p>
				<p class="p-content-chid">1.6.4出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的。</p>
				<p class="p-content-chid">1.6.5所收集的信息是您自行向社会公众公开的。</p>
				<p class="p-content-chid">1.6.6从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道。</p>
				<p class="p-content-chid">1.6.7符合所签合同约定的。</p>
				<p class="p-content-chid">1.6.8用于维护智慧生活10000号服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</p>
				<p class="p-content-chid">1.6.9学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的。</p>
				<p class="p-content-chid">1.6.10出于维护知识产权权利的需要，依法披露个人信息。</p>
				<p class="p-content-chid">1.6.11 法律法规规定的其他情形。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">2.我们如何使用Cookie和同类技术</p>
				<p class="p-content">
					2.1为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标志符、站点名称以及一些号码和字符。借助Cookie，网站能够记住您的用户身份、存储您的偏好。</p>
				<p class="p-content">
					我们不会将Cookie用于本政策所述目的之外的其他用途。您可根据自己的偏好管理或删除Cookie。如您的浏览器允许，您可以通过浏览器设置阻止Cookie。但如果您这么做，可能会影响您安全访问我们的网站，且可能在每一次访问我们的网站时需要更改用户设置。
				</p>
				<p class="p-content">2.2除Cookie之外，我们还使用了实体标签（Etag）来做静态资源的缓存，以便加速网站的访问速度，提升您的浏览体验。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">3.共享</p>
				<p class="p-content">除以下情形外，未经您同意，我们不会与智慧生活10000号之外的任何第三方分享您的信息：</p>
				<p class="p-content">3.1获得您的明确同意后，我们会与其他方分享您的个人信息。</p>
				<p class="p-content">3.2根据与您签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供。</p>
				<p class="p-content">3.3我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外分享您的个人信息。</p>
				<p class="p-content">
					3.4您的个人信息可能会与我们关联公司分享：为便于我们及关联公司向您提供各项产品或服务、验证您的身份、识别您的账号异常等，您的个人信息可能会与我们的关联公司共享。我们只会分享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
				</p>
				<p class="p-content">
					3.5与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些业务将由授权合作伙伴协助实现。我们可能会与合作伙伴共享您的某些个人信息，以更好地实现用户服务和智慧生活10000业务发展。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
				</p>
				<p class="p-content">目前，我们的授权合作伙伴包括以下类型：</p>
				<p class="p-content">a.
					广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱）与提供广告、分析服务的合作伙伴分享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便他不会识别到您个人。例如，我们可能会告知广告合作伙伴有多少人查看了他的广告。
				</p>
				<p class="p-content">b.
					供应商、服务提供商或其他合作伙伴。为了改进和完善我们的产品或服务，我们可能会将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们产品或服务的基本情况、协助我们向您提供产品或服务、投融资活动中的尽职调查等。例如，我们需要将您的订单号和订单金额与第三方支付机构（例如微信或支付宝等）共享以实现其确认您的支付指令并完成支付。
				</p>
				<p class="p-content">对我们与之共享个人信息的第三方，我们会与其签署严格的保密约定，要求他们按照本隐私政策及相关法律法规要求处理个人信息。</p>
				<p class="p-content">3.6在不透露单个用户隐私资料的前提下，智慧生活10000号有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">4.转让</p>
				<p class="p-content">目前我们不会将您的个人信息转让给智慧生活10000及关联公司外的任何第三方，但下列情况除外：</p>
				<p class="p-content">4.1获得您的明确同意后，我们会向其他方转让您的个人信息。</p>
				<p class="p-content">4.2在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">5.公开披露</p>
				<p class="p-content">我们仅会在以下情况下，公开披露您的个人信息：</p>
				<p class="p-content">5.1获得您明确同意后或基于您的主动选择。</p>
				<p class="p-content">
					5.2根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
				</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">6.信息的存储</p>
				<p class="p-content">6.1我们将从中华人民共和国境内获得的信息存放于中华人民共和国境内。如因业务需求或其他原因需要跨境传输的，我们会重新申请您的明确同意，并明确告知您出境个人信息类型。</p>
				<p class="p-content">6.2我们承诺您个人信息的存储时间始终处于合理必要期限内。</p>
				<p class="p-content">6.3当我们的产品或服务停止运营时，我们会及时停止对您个人信息的收集，将以推送通知、公告等形式通知您，并根据法律法规的要求尽快对已收集的个人信息进行删除或匿名化处理。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">7.我们如何保护您的个人信息</p>
				<p class="p-content">
					7.1我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受
					SSL 加密保护；我们同时对我们网站提供 https
					安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
				</p>
				<p class="p-content">7.2我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
				<p class="p-content">7.3互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他我们用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。
				</p>
				<p class="p-content">
					7.4互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
				</p>
				<p class="p-content">
					7.5在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
					同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况</p>
				<p class="p-content"></p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">8.您的权利</p>
				<p class="p-content">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
				<p class="p-content">8.1访问您的个人信息</p>
				<p class="p-content">您有权访问您的个人信息，法律法规规定的例外情况除外。</p>
				<p class="p-content">8.2更正您的个人信息</p>
				<p class="p-content">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以发送电子邮件至sashion@foxmail.com。我们将在30天内回复您的更正请求。</p>
				<p class="p-content">8.3删除您的个人信息</p>
				<p class="p-content">在以下情形中，您可以向我们提出删除个人信息的请求：</p>
				<p class="p-content-chid">1）如果我们处理个人信息的行为违反法律法规。</p>
				<p class="p-content-chid">2）如果我们收集、使用您的个人信息，却未征得您的同意。</p>
				<p class="p-content-chid">3）如果我们处理个人信息的行为违反了与您的约定。</p>
				<p class="p-content-chid">4）如果您不再使用我们的产品或服务，或您注销了账号。</p>
				<p class="p-content-chid">5）如果我们不再为您提供产品或服务。</p>
				<p class="p-content">
					若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
				</p>
				<p class="p-content">8.4改变您授权同意的范围</p>
				<p class="p-content">每个业务功能需要一些基本的个人信息才能得以完成（详见本政策第 1
					部分）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
				<p class="p-content">8.5个人信息主体注销账户</p>
				<p class="p-content">您随时可注销此前已注册的账户，您可以通过邮件至1407132015@qq.com与我们联系。注销前我们将验证您的个人身份等信息，以确保是您本人。</p>
				<p class="p-content">
					在注销账户后，我们将停止为您提供产品或服务，按照法律法规要求尽快删除您的个人信息或做匿名化处理。您注销账户的行为是不可逆行为，您重新注册智慧生活10000号的用户，即成为新的用户。您无法恢复已注销账户的任何信息或服务。</p>
				<p class="p-content">8.6约束信息系统自动决策</p>
				<p class="p-content">在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</p>
				<p class="p-content">8.7响应您的上述请求</p>
				<p class="p-content-chid">8.7.1为保障安全，我们可能会要求您先验证您的身份，再响应您的上述请求。您可以通过邮件至miz_service@163.com与我们联系，一般情况下我们将在 30
					天内作出回复。</p>
				<p class="p-content-chid">
					8.7.2对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
				</p>
				<p class="p-content-chid">8.7.3在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
				<p class="p-content-chid">A. 与国家安全、国防安全有关的。</p>
				<p class="p-content-chid">B. 与公共安全、公共卫生、重大公共利益有关的。</p>
				<p class="p-content-chid">C. 与犯罪侦查、起诉和审判等有关的。</p>
				<p class="p-content-chid">D. 有充分证据表明您存在主观恶意或滥用权利的。</p>
				<p class="p-content-chid">F. 涉及商业秘密的。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">9.我们如何处理未成年人的个人信息</p>
				<p class="p-content">9.1我们的产品、网站和服务主要面向成人。若您是 18
					周岁以下的未成年人，请不要注册成为智慧生活10000号的用户。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
				<p class="p-content">9.2如果您是未成年人的监护人，当您监护的未成年人注册成为智慧生活10000号的用户，请通过邮件至miz_service@163.com与我们联系。</p>
			</div>

			<div class="main-xieyi-pcontent">
				<p class="p-title">10. 本政策如何更新</p>
				<p class="p-content">10.1我们会适时根据具体情况对本隐私政策进行修订，并会通过公告、推送、邮件等适当方式提醒您。</p>
				<p class="p-content">10.2在您知晓或应当知晓上述更新后，您仍然选择继续使用我们的服务，视为您对更新后隐私政策的接受。</p>
			</div>

			<div class="main-xieyi-pcontent" style="margin-bottom:45px;">
				<p class="p-title">11. 如何联系我们</p>
				<p class="p-content">我们已设立了个人信息保护负责人，如果您对本隐私政策有任何疑问、意见或建议，可以通过以下方式与我们联系，一般情况下我们将在 15
					日内回复，发送邮件至：{{getQQService}}@qq.com</p>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters(["getQQService"]),
    },
	};
</script>
<style scoped>
	.agree-bg {
		width: 100%;
		background: #F4F4F4;
		overflow: hidden;
		display: flex;
		justify-content: center;
	}

	.main-xieyi-content {
		width: 995px;
		background: #fff;
		float: left;
		margin-left: 20px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.main-xieyi-title {
		margin-left: 25px;
		margin-top: 45px;
		font-size: 16px;
		color: #4A4A4A;
		margin-right: 25px;
		font-weight: bold;
	}

	.main-xieyi-pcontent p {
		margin-left: 25px;
		margin-right: 25px;
	}

	.p-content {
		font-size: 14px;
		color: #888888;
		margin-bottom: 20px;
		line-height: 22px;
	}

	.p-title {
		margin-top: 30px;
		margin-bottom: 25px;
		font-size: 14px;
		color: #4A4A4A;
		font-weight: bold;
	}

	.p-content-chid {
		font-size: 14px;
		color: #888888;
		margin-bottom: 15px;
		line-height: 22px;
	}
</style>
